import DefaultMainPage from "../../../pages/DefaultMainPage";
import PopupMaster from "./PopupMaster";
import PopupTable from "./PopupTable";

const popupMasterMenuItems = [
    {path: "/popupMaster", component: <PopupMaster/>, label: '팝업 관리'},
    {path: "/popupMaster/table", component: <PopupTable/>, label: '팝업 테이블'},
];

export const popupMasterRoutes = {
    path: "/popupMaster",
    component: <DefaultMainPage buttons={popupMasterMenuItems}/>,
    children: popupMasterMenuItems
}